import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../redux/modal/actions";
import { findNextRecommendationPlan } from "../constants/plansAndFeatures";
import Plans from "../views/app/plans/Plans";
import React from "react";
import { useBillingContext } from "../views/app/BillingProvider";

// useFeature -> plans & features
// Custom Hook to Check and Manage Feature Usage
const useFeature = (featureName) => {
  // Redux Store
  const { currentUser } = useSelector(({ authUser }) => authUser);
  const { usages } = currentUser;
  const userPlan = currentUser.plan;
  const currentUserFeatures = useSelector(
    ({ authUser }) => authUser.currentUserFeatures
  );
  const { standardPlans } = useSelector((state) => state.billingAndPlans);

  const dispatch = useDispatch();
  const { upgradePlanModal: modal } = useBillingContext();

  const checkFeature = React.useCallback((f) => {
    return f && currentUserFeatures[f]?.shouldAllow();
  }, [currentUserFeatures]);

  // Check if User Has the Feature
  const hasFeature = checkFeature(featureName);

  // Open Upgrade Plan Modal
  const upgradePlanModal = React.useCallback((f) => {
    modal(standardPlans, userPlan, usages, f);
  }, [standardPlans, usages, userPlan, modal]);

  // Close Upgrade Plan Modal
  const closeUpgradeModal = React.useCallback(() => {
    dispatch(closeModal("upgrade-plans"));
  }, [dispatch]);

  // Return Feature Information and Methods
  return { hasFeature, checkFeature, upgradePlanModal, closeUpgradeModal };
};

export default useFeature;
